"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dashboard = _interopRequireDefault(require("@uppy/dashboard"));
var _propTypes2 = require("./propTypes.js");
var _getHTMLProps = _interopRequireDefault(require("./getHTMLProps.js"));
var _nonHtmlPropsHaveChanged = _interopRequireDefault(require("./nonHtmlPropsHaveChanged.js"));
var _excluded = ["uppy"],
  _excluded2 = ["uppy"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * React Component that renders a Dashboard for an Uppy instance. This component
 * renders the Dashboard inline, so you can put it anywhere you want.
 */
var Dashboard = /*#__PURE__*/function (_Component) {
  function Dashboard() {
    _classCallCheck(this, Dashboard);
    return _callSuper(this, Dashboard, arguments);
  }
  _inherits(Dashboard, _Component);
  return _createClass(Dashboard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.installPlugin();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // eslint-disable-next-line react/destructuring-assignment
      if (prevProps.uppy !== this.props.uppy) {
        this.uninstallPlugin(prevProps);
        this.installPlugin();
      } else if ((0, _nonHtmlPropsHaveChanged.default)(this.props, prevProps)) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var _this$props$target = _objectSpread(_objectSpread({}, this.props), {}, {
            target: this.container
          }),
          uppy = _this$props$target.uppy,
          options = _objectWithoutProperties(_this$props$target, _excluded);
        this.plugin.setOptions(options);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.uninstallPlugin();
    }
  }, {
    key: "installPlugin",
    value: function installPlugin() {
      var _id$inline$this$props = _objectSpread(_objectSpread({
          id: 'react:Dashboard',
          inline: true
        }, this.props), {}, {
          target: this.container
        }),
        uppy = _id$inline$this$props.uppy,
        options = _objectWithoutProperties(_id$inline$this$props, _excluded2);
      uppy.use(_dashboard.default, options);
      this.plugin = uppy.getPlugin(options.id);
    }
  }, {
    key: "uninstallPlugin",
    value: function uninstallPlugin(props) {
      if (props === void 0) {
        props = this.props;
      }
      var _props = props,
        uppy = _props.uppy;
      uppy.removePlugin(this.plugin);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      return /*#__PURE__*/(0, _react.createElement)('div', _objectSpread({
        className: 'uppy-Container',
        ref: function ref(container) {
          _this.container = container;
        }
      }, (0, _getHTMLProps.default)(this.props)));
    }
  }]);
}(_react.Component);
Dashboard.propsTypes = {
  uppy: _propTypes2.uppy,
  disableInformer: _propTypes.default.bool,
  disableStatusBar: _propTypes.default.bool,
  disableThumbnailGenerator: _propTypes.default.bool,
  height: _propTypes2.cssSize,
  hideProgressAfterFinish: _propTypes.default.bool,
  hideUploadButton: _propTypes.default.bool,
  locale: _propTypes2.locale,
  metaFields: _propTypes2.metaFields,
  note: _propTypes.default.string,
  plugins: _propTypes2.plugins,
  proudlyDisplayPoweredByUppy: _propTypes.default.bool,
  showProgressDetails: _propTypes.default.bool,
  width: _propTypes2.cssSize,
  // pass-through to ThumbnailGenerator
  thumbnailType: _propTypes.default.string,
  thumbnailWidth: _propTypes.default.number
};
var _default = exports.default = Dashboard;